import { assocPath, mergeDeepWith } from "ramda";
/*
 * When concatiating arrays the second item(b) in the MergeDeepWith as a higher index then the previous item(a).
 * b has an index that is not zero and the previous items in the item are undefined: [undefined, {email: "test@test.com"}]
 * but a does contain an item at 0: [{email: "test@test.com"}], so concat fills in the value from b unless it's undefined,
 * if thet item is undefined then the item is retrieved from a.
 */
const concat = (a, b) => {
    const results = [];
    // we use an old school for loop because forEach does not loop over undefined
    // the way the assocPath work should ensure that b is the longest array
    // but has empty item at index 0, we load the empty array spots from a which
    // should have valid data
    for (let i = 0; i < b.length; i += 1) {
        if (b[i]) {
            results[i] = b[i];
        }
        else {
            results[i] = a[i];
        }
    }
    return results;
};
function buildNewDocumentFromJsonPathNodes(data) {
    let rootDocument = {};
    data.forEach((nodeItem) => {
        rootDocument = mergeDeepWith(concat, rootDocument, assocPath(nodeItem.path.slice(1), nodeItem.value, {}));
    });
    return rootDocument;
}
export default buildNewDocumentFromJsonPathNodes;
